// extracted by mini-css-extract-plugin
export default {"points":"Notification_points__5DBoH"};